import { render, staticRenderFns } from "./AssetVideoGeneration.vue?vue&type=template&id=823c04f0&lang=pug"
import script from "./AssetVideoGeneration.vue?vue&type=script&lang=js"
export * from "./AssetVideoGeneration.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoGeneration.vue?vue&type=style&index=0&id=823c04f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports